import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { ApplicationContext } from "../../context/application_ctx";
import { IconButtonMA, TextFieldMA } from "../../styles/styledComponents";
import { Close, Done } from "@mui/icons-material";
import { HttpStatusCode } from "axios";
import { font } from "../../styles/font";
import { theme } from "../../styles/theme";
import {
  getUploadCVS,
} from "../../api/controllers/registeredUserController";
import validator from "validator";
import {
  getAudit,
  getLicencBatch,
  uploadSingleDemo,
} from "../../api/controllers/dashboardController";

export default function RegisterEmployeeDialog({
  setOnBoardSnack,
  setError,
  setScrollerTrigger,
}) {
  // context
  const {
    isOpenRegisterEmployeeDialog,
    licenceType,
    setAuditList,
    header,
    setFilteredList,
    setLicenceBatchList,
    setIsOpenRegisterEmployeeDialog,
    setEmployeesList,
  } = useContext(ApplicationContext);
  console.log(licenceType, "licencecheck");

  const [epId, setEpId] = useState("");
  const [epName, setEpName] = useState({});
  const [epEmail, setEpEmail] = useState(null);
  const [epDesignation, setEpDesignation] = useState("");
  const [epDepartment, setEpDepartment] = useState("");
  // const [licenseStatus, setLicenseStatus] = useState("unallocated")
  const [loaderState, setLoaderState] = useState(false);

  function handleCloseRegisterDialog() {
    setIsOpenRegisterEmployeeDialog(false);
  }

  const handleRegisterEmployee = async () => {
    try {
      setLoaderState(true);

      let response = await uploadSingleDemo({
        employeeId: epId?.trim(),
        name: epName.firstName?.trim(),
        lastName: epName.lastName?.trim(),
        designation: epDesignation?.trim(),
        department: epDepartment?.trim(),
        email: epEmail?.trim(),
        licenseType:
          header === "Trial" || licenceType === "Trial" ? "Trial" : "standard",
      });

      setLoaderState(false);
      console.log(response, "response add");
      if (response.status === HttpStatusCode.Created) {
          handleCloseRegisterDialog();
        setError(response.data.message);
        setOnBoardSnack(true);
        let reloadEmployeeBatch = await getLicencBatch();
        let reloadEmployee = await getUploadCVS();
        console.log(reloadEmployee, "getEmployeesReg");

        setLicenceBatchList(reloadEmployeeBatch.data);
        setEmployeesList(reloadEmployee.data);
        let filteredData = reloadEmployee?.data?.filter((data) =>
        header === "Trial"
          ? data.licenseType === "Trial"
          : data.licenseType === "Standard"
      )
    
        setFilteredList(
         filteredData
        );
        console.log("pass");

        let reloadAudit = await getAudit();
        console.log(reloadAudit, "getAudit");

        setAuditList(reloadAudit.data?.auditLogs);
        if(filteredData?.length > 1){

            setScrollerTrigger(true);
        }
        // setTimeout(() => {
        //     let height = document.getElementById("scroller").scrollHeight
        //     let ele = document.getElementById("scroller").scrollBy({top:height,behavior:'smooth'})
        //    }, 500)

        // let tempArray = [...employeesList]

        // tempArray.push(response.data.employee);

        // setEmployeesList(tempArray);

        // setReloadEmployees(true);
        // setTimeout(() => {
        //   setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setError(response.data.message);
        setOnBoardSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      onClose={handleCloseRegisterDialog}
      open={isOpenRegisterEmployeeDialog}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "50%",
          //  minHeight: "60vh"
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" color={theme.col_3}>
            Add Employee
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <IconButtonMA
              disabled={
                (!epName?.firstName || !epName?.lastName) 
                  ? true
                  : !epEmail 
                  ? true
                  : epEmail && !validator.isEmail(epEmail)
                  ? true
                  // : epDesignation === ""
                  // ? true
                  : !epId ? true : false
              }
              size="small"
              onClick={handleRegisterEmployee}
            >
              <Done />
            </IconButtonMA>
            <IconButtonMA size="small" onClick={handleCloseRegisterDialog}>
              <Close />
            </IconButtonMA>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 1.5 }}>
        <Box
          py={2}
          px={1}
          display="flex"
          flexDirection="column"
          gap={2}
          position="relative"
        >
          {loaderState && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexGrow={1}
              width="100%"
              height="100%"
              zIndex={2}
              sx={{
                position: "absolute",
                top: "0",
                left: "0",
                background: "rgba(255, 255, 255, 0.28)",
                backdropFilter: "blur(0.2px)",
              }}
            >
              <CircularProgress sx={{ color: theme.col_2 }} size="50px" />
            </Box>
          )}

          <Box px={1} display="flex" alignItems="center" gap={2}>
            <Typography
              fontFamily={font.family.fm_2}
              fontSize={font.size.fs_3}
              fontWeight="bold"
              color={theme.col_2}
            >
              Enter the details of employee to add
            </Typography>
          </Box>
          <Box px={1} py={1} display="flex" gap={2 + 1}>
            <TextFieldMA
              required
              onChange={(e) => setEpName({...epName,firstName:e.target.value})}
              fullWidth
              inputProps={{maxLength:64}}
              label="First Name"
            />
            <TextFieldMA
              required
              // error={
              //     email === null
              //         ? false
              //         : !validator.isEmail(email) && email !== ""
              //             ? true
              //             : email === ""
              //                 ? true
              //                 : false
              // }
              // helperText={
              //     email === null
              //         ? ""
              //         : !validator.isEmail(email) && email !== ""
              //             ? "Enter valid email"
              //             : email === ""
              //                 ? "Email is required"
              //                 : ""
              // }
              onChange={(e) => setEpName({...epName,lastName:e.target.value})}

              fullWidth
              inputProps={{maxLength:64}}
              label="Last Name"
            />
          </Box>
          <Box px={1} py={1} display="flex" gap={2 + 1}>
            <TextFieldMA
              onChange={(e) => setEpId(e.target.value)}
              fullWidth
              inputProps={{maxLength:64}}
              required
              label="Employee Id"
            />
          <TextFieldMA
              required
              onChange={(e) => setEpEmail(e.target.value)}
              fullWidth
              inputProps={{maxLength:64}}
              label="Employee Email"
              error={
                epEmail === null
                  ? false
                  : !validator.isEmail(epEmail) && epEmail !== ""
                  ? true
                  : epEmail === ""
                  ? true
                  : false
              }
              helperText={
                epEmail === null
                  ? ""
                  : !validator.isEmail(epEmail) && epEmail !== ""
                  ? "Enter valid email"
                  : epEmail === ""
                  ? "Email is required"
                  : ""
              }
            />
          </Box>

          <Box px={1} py={1} display="flex" gap={2 + 1}>
           
            <TextFieldMA
              onChange={(e) => setEpDesignation(e.target.value)}
              fullWidth
              label="Employee Designation"
              inputProps={{maxLength:20}}

            />
              <TextFieldMA
              onChange={(e) => setEpDepartment(e.target.value)}
              fullWidth
              label="Employee Department"
              inputProps={{maxLength:20}}

            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
